(() => {
  if (window.roompoemNavigationReady) return;
  window.roompoemNavigationReady = true;
  const menus = () => [...document.querySelectorAll('[data-desktop-menu]')];
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('[data-desktop-menu]') && event.target.open) menus().filter(menu => menu !== event.target).forEach(menu => menu.open = false);
  }, true);
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    const menu = event.target.closest('[data-desktop-menu]');
    if (menu) menu.open = true;
  });
  document.addEventListener('pointerout', event => {
    const menu = event.target.closest('[data-desktop-menu]');
    if (menu && !menu.contains(event.relatedTarget) && !menu.contains(document.activeElement)) menu.open = false;
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-desktop-menu]')) menus().forEach(menu => menu.open = false);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    menus().filter(menu => menu.open).forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('focusout', event => {
    const menu = event.target.closest('[data-desktop-menu]');
    if (menu && !menu.contains(event.relatedTarget)) menu.open = false;
  });
})();
